var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2 0C14.2 0 5.8 0 5.8 0C2.2 0 0 2.2 0 5.8C0 5.8 0 14.2 0 14.2C0 17.8 2.2 20 5.8 20C5.8 20 14.2 20 14.2 20C17.8 20 20 17.8 20 14.2C20 14.2 20 5.8 20 5.8C20 2.2 17.8 0 14.2 0C14.2 0 14.2 0 14.2 0ZM8.9 14.2C8.5 14.2 7.3 14.3 7.3 15.8C7.3 16.2 7 16.6 6.5 16.6C6.1 16.6 5.8 16.3 5.7 15.9C5.7 15.5 5.6 14.3 4.1 14.3C3.7 14.3 3.3 14 3.3 13.5C3.3 13.1 3.6 12.8 4 12.7C4.4 12.7 5.6 12.6 5.6 11.1C5.6 10.7 5.9 10.3 6.4 10.3C6.8 10.3 7.1 10.6 7.2 11C7.2 11.4 7.3 12.6 8.8 12.6C9.2 12.6 9.6 12.9 9.6 13.4C9.6 13.8 9.3 14.2 8.9 14.2C8.9 14.2 8.9 14.2 8.9 14.2ZM15.8 9.6C15.4 9.6 12 9.7 12 13.4C12 13.8 11.7 14.2 11.2 14.2C10.7 14.2 10.5 13.9 10.4 13.5C10.4 13.1 10.3 9.7 6.6 9.7C6.2 9.7 5.8 9.4 5.8 8.9C5.8 8.5 6.1 8.2 6.5 8.1C6.9 8.1 10.3 8 10.3 4.3C10.3 3.9 10.6 3.5 11.1 3.5C11.6 3.5 11.8 3.8 11.9 4.2C11.9 4.6 12 8 15.7 8C16.1 8 16.5 8.3 16.5 8.8C16.5 9.3 16.2 9.6 15.8 9.6C15.8 9.6 15.8 9.6 15.8 9.6Z",
    transform: "translate(2 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldai);
export default __webpack_public_path__ + "static/media/vuesaxboldai.b44679b0b2b752e69c247ad77f5cfee4.svg";
export { ForwardRef as ReactComponent };